import { Component, HostListener, Input, OnInit } from '@angular/core';
import { AlertController, ModalController } from '@ionic/angular';
import { AssetInScene } from 'src/app/models/AssetInScene';
import { MediaAsset } from 'src/app/models/assets/MediaAsset';
import { Model3DAsset } from 'src/app/models/assets/Model3DAsset';
import { Scene } from 'src/app/models/Scene';
import { Model3DSceneAssetRelation } from 'src/app/models/scene-asset-relations/model3DSceneAssetRelation';
import { AssetTypeService } from 'src/app/services/asset-type.service';
import { FileService } from 'src/app/services/file.service';
import { ValidationService } from 'src/app/services/validation.service';

@Component({
  selector: 'app-model3d-asset-wizard',
  templateUrl: './model3d-asset-wizard.component.html',
  styleUrls: ['./model3d-asset-wizard.component.scss'],
})
export class Model3dAssetWizardComponent implements OnInit {

  @Input('assetType') assetType: string;
  @Input('assetInScene') assetInScene: AssetInScene;
  @Input('existingAssetsInScene') existingAssetsInScene: AssetInScene[] = [];
  @Input('existingScenes') existingScenes: Scene[] = [];
  @Input('editing') editing: boolean = false;

  public steps: any = [];

  public uploadProperties: any = {
    fileUploaded: false,
    fileName: "",
  }

  public currentStepInfo: any = {
    currentStepIndex: 0,
    currentSubStepIndex: 0,
    needHelp: false,
    uploadProperties: this.uploadProperties
  }
  public assetTypeId: number = 7;

  constructor(
    public assetTypeService: AssetTypeService,    
    public modalController: ModalController,
    private alertController: AlertController,
    public validationService: ValidationService,
    public fileService: FileService,
  ){ 
    this.steps = [{
      index: 1,
      description: "Introduction",
      complete: false,
      active: true
    }, {
      index: 2,
      description: "Actions",
      complete: false,
      active: false
    }, {
      index: 3,
      description: "Learning Objectives",
      complete: false,
      active: false
    }];
   }

  ngOnInit() {
    if (!this.editing)
    this.setUpAssetScale(this.assetInScene.sceneAssetRelation, '1', '1', '1');
    this.setUpModel3DAssetRotation((this.assetInScene.sceneAssetRelation as Model3DSceneAssetRelation));

    this.assetTypeId = this.assetTypeService.getId(this.assetType);

    if(this.editing){
      var model3dAsset = this.assetInScene.baseAsset as Model3DAsset;
      if (model3dAsset.src !="")
      this.currentStepInfo.uploadProperties.fileName = model3dAsset.name;
    }
  }

  async closeModal() {
    const alert = await this.alertController.create({
      header: 'Are you sure?',
      message: 'Are you sure you want to leave? Any changes will not be saved.',
      cssClass: 'leave-alert quizard-alert quizard-leave-alert',
      buttons: [{
        text: 'Yes',
        cssClass: '',
        handler: () => {
          this.modalController.dismiss();
        }
      }, {
        text: 'No',
        cssClass: '',
        handler: () => {
          alert.dismiss();
        }
      }
      ]
    });
    await alert.present();
  }

  validateModel3dProperties(): boolean{

    let model3dAsset = this.assetInScene.baseAsset as MediaAsset;

    if (!model3dAsset.name || model3dAsset.name.trim().length == 0 || this.currentStepInfo.uploadProperties.fileName=="") {
      this.goToStep(0);
      return false;
    }
    return true;
  }

  async saveModel() {
    if (this.validateModel3dProperties() == false) {
      return;
    }

    let model3dAsset = this.assetInScene.baseAsset as Model3DAsset;
    let model3dSrcResult = model3dAsset.src;
    if(this.currentStepInfo.uploadProperties.fileUploaded == true){
      //UPLOADS THE FILE
      model3dSrcResult = await this.uploadModel3dFile();
      model3dAsset.src = model3dSrcResult;
    }

    let data: any = {
      assetForScene: this.assetInScene,
      assetType: this.assetType,
    }
    this.modalController.dismiss(data);
  }

  setUpAssetScale(sceneAssetRelation, x: string, y: string, z: string) {
    sceneAssetRelation.xScale = x;
    sceneAssetRelation.yScale = y;
    sceneAssetRelation.zScale = z;
    sceneAssetRelation.scale = x + ' ' + y + ' ' + z;
  }

  setUpModel3DAssetRotation(model3DSceneAssetRelation: Model3DSceneAssetRelation) {
    if (!model3DSceneAssetRelation.xRot) model3DSceneAssetRelation.xRot = '0';
    if (!model3DSceneAssetRelation.yRot) model3DSceneAssetRelation.yRot = '0';
    if (!model3DSceneAssetRelation.zRot) model3DSceneAssetRelation.zRot = '0';
    model3DSceneAssetRelation.rotation = model3DSceneAssetRelation.xRot + ' ' + model3DSceneAssetRelation.yRot + ' ' + model3DSceneAssetRelation.zRot;
  }
  
  exitHelp() {
    this.currentStepInfo.needHelp = false;
  }

  goToHelp() {
    this.currentStepInfo.needHelp = true;
  }

  goToStep(step: number) {
    if (this.currentStepInfo.currentStepIndex == step){
      this.currentStepInfo.needHelp = false;
      return;
    }
    this.steps[this.currentStepInfo.currentStepIndex].complete = true;
    this.currentStepInfo.currentStepIndex = step;
    this.steps[this.currentStepInfo.currentStepIndex].active = true;
    this.steps[this.currentStepInfo.currentStepIndex].complete = false;
    this.currentStepInfo.needHelp = false;
  }

  previousStep() {
      if (this.currentStepInfo.currentStepIndex > 0)
        this.goToStep(this.currentStepInfo.currentStepIndex - 1);
  }

  nextStep(){
    this.goToStep(this.currentStepInfo.currentStepIndex +1);
  }

  fileUpload(event) {
    console.log("beginning")
    if (event.target.files.length == 0) return;
    console.log("middle")

    this.validationService.setFileType(event);
    if (!this.validationService.doesUploadedFileMatchAssetType(this.assetTypeId)) {
      this.validationService.createAlert('Wrong Media Type Uploaded.');
      return;
    } else if (!this.validationService.isFileFormatCorrect(this.assetTypeId)) {
      this.validationService.createAlert('Unsupported File Format.');
      return;
    }
    console.log("end")
    this.uploadProperties.fileName = String(event.target.files[0].name).substring(0, 40);
    this.uploadProperties.fileUploaded = true;
  }
  
  uploadModel3dFile(): Promise<string>{
    return new Promise<string>((resolve) => {
      let input: any = document.querySelector('#file-input');
      var file = input.files[0];
      var compress = false;
      
      let title = "Uploading " + this.assetInScene.baseAsset.name + " 3D model.";
      this.fileService.batchUploadFile(file, '5a0ffb5a-475d-4307-bf05-237f82a9302d', compress, "", title).then((result) =>{
        resolve(result);
      });
    });
  }
}
